import React from 'react'

const Tahqeeqtag = ({text}) => {
  return (
    <><p className="bg-theme h-fit rounded-sm text-white w-fit px-[18px] py-[3px] text-base md:text-[1.2rem]">{text}:</p></>
  )
}

export default Tahqeeqtag